import VueMomentsAgo from './components/moments-ago.vue'
export default VueMomentsAgo